type Seo = {
    [index: string]: {
        t: string;
        d?: string;
    };
};

export const seoData: Seo = {
    cart: {
        t: 'Cart | Smart AZ Minerals',
        d: 'All the products that are added to cart. Review here before checkout.',
    },
    'contact-us': {
        t: 'Contact Smart AZ Minerals',
        d: 'Send Us A Message. We are situated at 215 5th Ave. Ouray, CO. You can contact us at  + 1 970 708-7627.',
    },
    'liquid-mineral-faqs': {
        t: 'Liquid Mineral FAQ’s | Smart AZ Minerals',
        d: 'Here are most frequently asked questions.',
    },
    benefits: {
        t: 'Natural Mineral Water Benefits | Smart AZ Minerals',
        d: 'Minerals are required for a body to maintain health. Most natural water sources throughout the World have at least some mineral content. Water filtration and many processed bottled waters have reduced mineral content that helps contribute to mineral deficiencies.',
    },
    brochure: {
        t: 'Brochure | Smart AZ Minerals',
        d: 'Download Smart AZ Mineral Water Brochure',
    },
    'our-process': {
        t: 'Mineral Water Content Process | Smart AZ Minerals',
        d: 'We never use synthetic minerals or ingredients in any of our products. To ensure that every mineral we use is always 99.99% pure, we only buy minerals awarded a certificate for proof of purity from our mineral sources in the United States of America.',
    },
    'our-story': {
        t: 'Mineral Supplement Company | Smart AZ Minerals',
        d: 'Smart A-Z Minerals is determined to provide healthy and safe ionic minerals for our customers. We will use only the highest quality minerals and ultra clean bottling practices in production of our products.',
    },
    all: {
        t: 'Products | Smart AZ Minerals',
        d: 'Here is the complete list of products sold by Smart AZ Minerals.',
    },
    collections: {
        t: 'Collections | Smart AZ Minerals',
        d: 'Here is the complete list of products collection sold by Smart AZ Minerals',
    },
    events: {
        t: 'Events | Smart AZ Minerals',
        d: 'Here are the events that were held and will be held in the future.',
    },
    disclaimer: {
        t: 'Disclaimer | Smart AZ Minerals',
        d: 'Smart AZ Minerals product listings, descriptions, and comments have not been reviewed by the Food and Drug Administration and they are not meant to diagnose, administer, heal or deter illness.',
    },
    'terms-of-service': {
        t: 'Terms of Service | Smart AZ Minerals',
        d: 'Read Smart AZ Minerals terms of service.',
    },
    'refund-policy': {
        t: 'Refund Policy | Smart AZ Minerals',
        d: 'Read Smart AZ Minerals refund policy.',
    },
    'shipping-policy': {
        t: 'Shipping Policy | Smart AZ Minerals',
        d: 'Read Smart AZ Minerals shipping policy.',
    },
    'privacy-policy': {
        t: 'Privacy Policy | Smart AZ Minerals',
        d: 'Read Smart AZ Minerals privacy policy.',
    },
    blog: {
        t: 'Blog | Smart AZ Minerals',
        d: 'Complete list of articles and blog posts by Smart AZ Minerals',
    },
    account: {
        t: 'My Account  | Smart AZ Minerals',
        d: 'See you account details and order history.',
    },
    login: {
        t: 'Login | Smart AZ Minerals',
        d: 'Login to Smart AZ Minerals to see your account details and order history.',
    },
    register: {
        t: 'Register Account | Smart AZ Minerals',
        d: 'Register account to Smart AZ Minerals to see your order history.',
    },
    recover: {
        t: 'Recover Account | Smart AZ Minerals',
        d: 'Recover your account by resetting its password.',
    },
    reset: {
        t: 'Reset Account | Smart AZ Minerals',
        d: 'Set new password for your account.',
    },
};
